import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Typography, Input, Button, Spin, Carousel } from 'antd';
import { Link, useParams } from 'react-router-dom';
import { FacebookOutlined, GlobalOutlined, WhatsAppOutlined, YoutubeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { BACKEND_URL } from '../Backend'; 
import SelectCuatrimestre from '../pages/SelectCuatrimestre';
import axios from 'axios';

// Importar imágenes del carousel y footer
import carousel3 from "../img/carousel3.webp";
import carousel4 from "../img/carousel4.webp";
import footerImage from '../img/footer.webp';

const { Meta } = Card;
const { Title } = Typography;
const { Search } = Input;

function AlumnosPublico() {
  
  const navigation = useNavigate();
  const { pk_carrera } = useParams();
  const [alumnosporcarreras, setAlumnosPorCarreras] = useState([]);
  const [nombreCarrera, setNombreCarrera] = useState('');
  const [cuatrimestreSeleccionado, setCuatrimestreSeleccionado] = useState('');
  const [filtro, setFiltro] = useState('');
  const [cargando, setCargando] = useState(false);
  const [refrescar, setRefrescar] = useState(false);

  // Función para manejar el cambio de cuatrimestre
  const handleCuatrimestreChange = (cuatrimestre) => {
    setCuatrimestreSeleccionado(cuatrimestre);
    console.log('Cuatrimestre seleccionado:', cuatrimestre);
  };

  useEffect(() => {
    // Scroll to top cuando cambie la página
    window.scrollTo(0, 0);
    setCargando(true);

    axios.get(`${BACKEND_URL}/alumnosPorCarrera/${pk_carrera}`)
    .then(async (response) => {
      const alumnos = response.data;

      const alumnosConArchivos = await Promise.all(alumnos.map(async alumno => {
        try {
          // Obtener la lista de archivos del alumno
          const res = await axios.get(`${BACKEND_URL}/listarArchivos/${encodeURIComponent(alumno.nombre_carrera)}/${encodeURIComponent(alumno.cuatrimestre_grupo)}/${encodeURIComponent(alumno.nombre_alumno)}`);
          
          const archivos = res.data.archivos || [];
          const tieneArchivos = archivos.length > 0;
          const primerArchivo = tieneArchivos ? archivos[0] : null;

          return {
            ...alumno,
            archivoExiste: tieneArchivos,
            nombreArchivo: primerArchivo,
            archivos: archivos 
          };
        } catch (error) {
          console.error('Error al obtener archivos del alumno:', error);
          return {
            ...alumno,
            archivoExiste: false,
            nombreArchivo: null,
            archivos: []
          };
        }
      }));

      setAlumnosPorCarreras(alumnosConArchivos);

      if (response.data.length > 0) {
        setNombreCarrera(response.data[0].nombre_carrera);
      } else {
        setNombreCarrera('Carrera no encontrada');
      }
    })
    .catch((error) => {
      console.error('Error al obtener alumnos de la carrera:', error);
      setNombreCarrera('Error al cargar la carrera');
    }).finally(() => {
      setCargando(false);
    });

  }, [pk_carrera, navigation, refrescar]);

  // Filtrar alumnos por nombre Y cuatrimestre
  const alumnosFiltrados = alumnosporcarreras.filter(alumno => {
    // Filtro por texto (nombre, cuatrimestre, matrícula)
    const cumpleFiltroTexto = 
      alumno.nombre_alumno.toLowerCase().includes(filtro.toLowerCase()) ||
      alumno.cuatrimestre_grupo.toLowerCase().includes(filtro.toLowerCase()) ||
      (alumno.matricula && alumno.matricula.toString().toLowerCase().includes(filtro.toLowerCase()));
    
    // Filtro por cuatrimestre seleccionado
    const cumpleFiltroCuatrimestre = 
      !cuatrimestreSeleccionado || 
      alumno.cuatrimestre_grupo.includes(cuatrimestreSeleccionado);
    
    return cumpleFiltroTexto && cumpleFiltroCuatrimestre;
  });

  return(
    <div style={{ padding: '20px', minHeight: '100vh' }}>
      {/* Carousel */}
      <Carousel autoplay autoplaySpeed={5000} dotPosition="bottom">
        <div>
          <img src={carousel4} alt="Slide 1" style={{ width: '100%', maxHeight: '340px', objectFit: 'cover' }} />
        </div>
        <div>
          <img src={carousel3} alt="Slide 2" style={{ width: '100%', maxHeight: '340px', objectFit: 'cover' }} />
        </div>
        <div>
          <img src={carousel3} alt="Slide 3" style={{ width: '100%', maxHeight: '340px', objectFit: 'cover' }} />
        </div>
        <div>
          <img src={footerImage} alt="Slide 4" style={{ width: '100%', maxHeight: '340px', objectFit: 'cover' }} />
        </div>
      </Carousel>

      <Spin spinning={cargando} size="large" tip="Cargando...">
        
        {/* Título principal */}
        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <Title level={2}>¡Bienvenidos al repositorio de tesis y memorias!</Title>
          <Title level={4}>Explora los trabajos académicos más destacados de nuestra universidad.</Title>
        </div>

       

        {/* Título de la carrera */}
        <Title level={3} style={{ marginTop: '40px', textAlign: 'center' }}>{nombreCarrera}</Title>
        
        {/* Botón de regresar centrado */}
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <Button style={{backgroundColor:'blue', color: 'white'}}
            onClick={() => {
                navigation(-1);
                // Pequeño delay para que termine la navegación
                setTimeout(() => {
                window.scrollTo(0, 0);
                }, 100);
            }}
            size="large"
            >
            ← Regresar
            </Button>
        </div>
        
        {/* Select de cuatrimestre */}
        <div style={{ marginBottom: 20, textAlign: 'center' }}>
          <label style={{ display: 'block', marginBottom: 8, fontWeight: 'bold' }}>
            Filtrar por cuatrimestre:
          </label>
          <SelectCuatrimestre
            value={cuatrimestreSeleccionado}
            onCuatrimestreChange={handleCuatrimestreChange}
            placeholder="Todos los cuatrimestres"
            style={{ width: 300 }}
          />
        </div>

        {/* Mostrar contador de resultados */}
        <div style={{ marginBottom: 16, color: '#666', textAlign: 'center' }}>
          {alumnosFiltrados.length} alumno(s) encontrado(s)
          {cuatrimestreSeleccionado && ` en ${cuatrimestreSeleccionado}° cuatrimestre`}
        </div>

        <Row gutter={[16, 16]} justify="center">
          {alumnosFiltrados.map((alumno, index) => (
            <Col key={index} xs={24} sm={12} md={8} lg={6} xl={5}>
              <Card
                hoverable
                style={{
                  borderRadius: '12px',
                  overflow: 'hidden',
                  textAlign: 'center',
                  height: '100%',
                }}
                cover={
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: 'auto',
                      maxHeight: '400px',
                      padding: '10px',
                      backgroundColor: '#f0f0f0'
                    }}
                  >
                    <div style={{ 
                      fontSize: '60px', 
                      color: '#999',
                      width: '70%',
                      height: '150px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      📄
                    </div>
                  </div>
                }
              >
                <Meta title={alumno.nombre_alumno} description={`${alumno.cuatrimestre_grupo} - ${alumno.matricula}`} />
                {alumno.archivoExiste && alumno.nombreArchivo && (
                  <div style={{ marginTop: '10px' }}>
                    <Button
                      type="link"
                      href={`${BACKEND_URL}/archivos/${encodeURIComponent(alumno.nombre_carrera)}/${encodeURIComponent(alumno.cuatrimestre_grupo)}/${encodeURIComponent(alumno.nombre_alumno)}/${encodeURIComponent(alumno.nombreArchivo)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ver PDF
                    </Button>
                  </div>
                )}
              </Card>
            </Col>
          ))}
        </Row>

        {/* Mensaje cuando no hay resultados */}
        {alumnosFiltrados.length === 0 && !cargando && (
          <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
            No se encontraron alumnos con los filtros aplicados
          </div>
        )}

        {/* Footer con imagen */}
        <div style={{ marginTop: '60px' }}>
          <img
            src={footerImage}
            alt="Footer"
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: '500px',
              objectFit: 'cover',
              display: 'block',
            }}
          />
        </div>

        {/* Información de contacto */}
        <Title style={{ display: 'flex', justifyContent: 'center' }} level={5}>
          UTESC. Camino al Guasimal S/N, al Noroeste de la Ciudad, Colonia Centro, C.P. 82400, Escuinapa, Sinaloa, México. Teléfono (695) 110 5779
        </Title>
        
        <br />
        
      

      </Spin>
    </div>
  );
};

export default AlumnosPublico;